export const defaultDateFormat = 'dddd, MMMM D, YYYY';
